// Structural data only — labels/serves/risks/route come from i18n (data.cycles.<id>).
export const CYCLES = [
  { id: "A", planId: "seasonal" },
  { id: "B", planId: "nomad" },
  { id: "C", planId: "family" },
  { id: "D", planId: "black" },
  { id: "E", planId: "trader" },
];
